import { FormControl, MenuItem, Select } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import React from 'react';

const ModernSelect = ({ ariaLabel, disabled = false, onChange, options, value }) => {
  const selectedOption =
    options.find((option) => option.value === value) || options[0];
  const SelectedIcon = selectedOption.Icon;

  return (
    <FormControl
      className="announcement-question__select-control"
      fullWidth
      variant="outlined"
    >
      <Select
        disabled={disabled}
        value={selectedOption.value}
        onChange={onChange}
        renderValue={() => (
          <span className="announcement-question__select-value">
            <span className="announcement-question__select-icon">
              <SelectedIcon />
            </span>
            <span>{selectedOption.label}</span>
          </span>
        )}
        inputProps={{ 'aria-label': ariaLabel }}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
          getContentAnchorEl: null,
          PaperProps: { className: 'announcement-question-menu' },
        }}
      >
        {options.map((option) => {
          const OptionIcon = option.Icon;
          const isSelected = option.value === selectedOption.value;

          return (
            <MenuItem
              className="announcement-question-menu__item"
              key={option.value}
              value={option.value}
            >
              <span className="announcement-question-menu__icon">
                <OptionIcon />
              </span>
              <span className="announcement-question-menu__copy">
                <strong>{option.label}</strong>
                <small>{option.description}</small>
              </span>
              {isSelected && (
                <Check className="announcement-question-menu__check" />
              )}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default ModernSelect;
